import React, { useEffect } from 'react';
import { AlertCircle, X, LogIn } from 'lucide-react';

export function SessionExpiredBanner({ visible, onSignIn, onDismiss }) {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [visible, onDismiss]);

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`
        fixed top-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-lg z-[60]
        transition-all duration-300 ease-in-out
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-12 pointer-events-none'}
      `}
    >
      <div className="flex items-center justify-between p-4 space-x-4 bg-surface rounded-lg shadow-lg border border-border">
        <div className="flex items-center space-x-3">
          <AlertCircle className="h-6 w-6 text-status-error flex-shrink-0" />
          <div>
            <h3 className="font-semibold text-text-primary">Session Expired</h3>
            <p className="text-sm text-text-secondary">Please sign in again to continue.</p>
          </div>
        </div>
        <div className="flex items-center flex-shrink-0 space-x-2">
          <button
            onClick={onSignIn}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-primary bg-surface-light hover:bg-border rounded-md transition-colors"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Sign In
          </button>
          <button
            onClick={onDismiss}
            aria-label="Dismiss"
            className="p-1 rounded-md text-text-muted hover:text-text-primary hover:bg-surface-light transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
